import React, { forwardRef } from 'react';
import styled from 'styled-components';

const StyledSwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

const StyledSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.blueGray};
  transition: 0.4s;

  &:before {
    position: absolute;
    content: '';
    width: 24px;
    height: 24px;
    left: 7.14%;
    right: 50%;
    top: 12.5%;
    bottom: 12.5%;
    background-color: ${({ theme }) => theme.components.radioButtons.borderColor.unselected};
    transition: 0.4s;
  }

  input:checked + & {
    background-color: ${({ theme }) => theme.components.radioButtons.backgroundColor.selected};
    border: 1px solid ${({ theme }) => theme.components.radioButtons.borderColor.selected};

    &:before {
      transform: translateX(18px);
      left: 18%;
      right: 7.14%;
      top: 12.5%;
      bottom: 12.5%;
      background-color: ${({ theme }) => theme.components.radioButtons.color.selected};
    }
  }

  &.round {
    border: none;
    border-radius: 34px;

    &:before {
      border-radius: 50%;
    }
  }
`;

const StyledLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 56px;
  height: 32px;
  background: #d2ffd5;
  border-radius: 100px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
`;

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {}

const ToggleSwitch = forwardRef<HTMLInputElement, Props>((props, ref) => (
  <StyledLabel>
    <StyledSwitchInput {...props} type="checkbox" ref={ref} />
    <StyledSlider className="round" />
  </StyledLabel>
));

export default ToggleSwitch;
